import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import CommentBox from '../../../CommentBox';
import SquareHeartFilled from '../../../Icons/SquareHeartFilled';
import SquareHeartOutlined from '../../../Icons/SquareHeartOutlined';
import Timestamp from '../../../Timestamp';
import { dateDiff } from '../../../Timestamp/functions';
import shortenNumber from '../../../utils/shortenNumber';
import { IconSize } from '../../../Icons/IconWrap';
import { withMobileContext } from '../../../Context';
import { withVerification, } from '../../../VerificationPopup/withVerification';
import { withCommentContext, } from '../CommentContext/CommentContext';
import s from '../../Comment.scss';
import threadStyles from '../../../CommentThread/CommentThread.scss';
var CommentFooter = /** @class */ (function (_super) {
    tslib_1.__extends(CommentFooter, _super);
    function CommentFooter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickLike = function () {
            // don't allow liking your own comment
            if (_this.props.comment.isAuthor) {
                return;
            }
            if (_this.props.comment.isLiked) {
                _this.props.onUnlike && _this.props.onUnlike(_this.props.comment);
            }
            else {
                _this.props.onLike && _this.props.onLike(_this.props.comment);
            }
        };
        _this.onClickEdit = function () {
            var _a = _this.props, isVerificationNeeded = _a.isVerificationNeeded, pushVerificationPopup = _a.pushVerificationPopup, setEditingState = _a.setEditingState;
            if (isVerificationNeeded) {
                pushVerificationPopup('comment');
                return;
            }
            setEditingState('editing');
        };
        _this.onCloseEditor = function () {
            var setEditingState = _this.props.setEditingState;
            setEditingState('none');
        };
        _this.onClickReply = function () {
            var _a = _this.props, isVerificationNeeded = _a.isVerificationNeeded, pushVerificationPopup = _a.pushVerificationPopup, isReplying = _a.isReplying, setEditingState = _a.setEditingState;
            if (isVerificationNeeded) {
                pushVerificationPopup('comment');
                return;
            }
            setEditingState(isReplying ? 'none' : 'replying');
        };
        _this.onReplyDone = function (result) {
            var _a = _this.props, setEditingState = _a.setEditingState, onReplyPosted = _a.onReplyPosted;
            setEditingState('none');
            onReplyPosted && result.comment && onReplyPosted(result);
        };
        return _this;
    }
    CommentFooter.prototype.render = function () {
        var _a = this.props, comment = _a.comment, className = _a.className, showBasicFooter = _a.showBasicFooter, isMobile = _a.isMobile, isReplying = _a.isReplying, isLoggedIn = _a.isLoggedIn, canPostComment = _a.canPostComment, isCommentVisible = _a.isCommentVisible;
        if (!isCommentVisible) {
            return null;
        }
        if (showBasicFooter) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: classnames(s['footer'], className) }, this.renderEditReplyDelete(comment)),
                isReplying && this.canReply(comment) && this.renderReply(comment)));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classnames(s['footer'], className) },
                isMobile
                    ? this.renderTime(comment)
                    : this.renderEditReplyDelete(comment),
                (!isLoggedIn || !!canPostComment) && (React.createElement("span", { className: s['like-separator'] }, "\u00A0 \u00B7 \u00A0")),
                this.renderLikeButton(),
                isMobile && this.renderEditReplyDelete(comment)),
            isReplying && this.canReply(comment) && this.renderReply(comment)));
    };
    CommentFooter.prototype.renderLikeButton = function () {
        var _a = this.props, t = _a.t, comment = _a.comment, isMobile = _a.isMobile;
        var isAuthor = comment.isAuthor, isLiked = comment.isLiked, likes = comment.likes;
        var HeartIcon = isLiked ? SquareHeartFilled : SquareHeartOutlined;
        var heartClasses = classnames(isLiked ? s['liked'] : s['like'], isAuthor && s['not-clickable']);
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: s['likebutton'], onClick: this.onClickLike },
                React.createElement(HeartIcon, { size: IconSize.MEDIUM, className: heartClasses })),
            likes > 0 && (React.createElement("span", { className: s['likes'] },
                shortenNumber(likes),
                " ",
                isMobile && t('comment.action.likes')))));
    };
    CommentFooter.prototype.renderReply = function (comment) {
        var _a = this.props, currentUser = _a.currentUser, indent = _a.indent, commentBoxClassName = _a.commentBoxClassName, canPostComment = _a.canPostComment, compact = _a.compact;
        return (React.createElement("div", { className: threadStyles["reply-outdent-" + indent] },
            React.createElement(CommentBox, { className: commentBoxClassName, onPublishSuccess: this.onReplyDone, id: "reply-" + comment.commentId, commentableType: comment.typeId, commentableItemId: comment.itemId, user: currentUser, replyComment: comment, autoFocus: true, onClose: this.onCloseEditor, canPostComment: !!canPostComment, compact: compact })));
    };
    CommentFooter.prototype.renderTime = function (comment) {
        var _a = this.props, t = _a.t, isMobile = _a.isMobile;
        var isEdited = !!comment.edited;
        var timestamp = isEdited ? comment.edited : comment.posted;
        var showEditedPrefix = isEdited && !isMobile;
        return (React.createElement(React.Fragment, null,
            React.createElement("a", { key: "comment-link", href: Url.commentLink(comment.typeId, comment.itemId, comment.commentId), className: s['timestamp'] },
                showEditedPrefix && t('comment.info.edited') + " ",
                React.createElement(Timestamp, { timestamp: timestamp, isCapitalized: !showEditedPrefix }))));
    };
    CommentFooter.prototype.renderEditReplyDelete = function (comment) {
        var _a = this.props, t = _a.t, canPostComment = _a.canPostComment, isLoggedIn = _a.isLoggedIn;
        if (!canPostComment && !!isLoggedIn) {
            return null;
        }
        return (React.createElement("span", { className: s['reply-and-edit'] },
            this.canEdit(comment) && (React.createElement(React.Fragment, null,
                React.createElement("a", { className: s['action'], onClick: this.onClickEdit }, t('comment.action.edit')),
                ' ',
                "\u00A0 \u00B7 \u00A0")),
            React.createElement("a", { className: classnames(s['reply-button'], s['action']), onClick: this.onClickReply }, t('comment.action.reply'))));
    };
    CommentFooter.prototype.canReply = function (comment) {
        return !comment.isHidden && !comment.isSpam;
    };
    CommentFooter.prototype.canEdit = function (comment) {
        // Limited to 1 day since post
        return (comment.isAuthor &&
            dateDiff(new Date().toISOString(), comment.posted, 'days') === 0);
    };
    CommentFooter.defaultProps = {
        canPostComment: true,
    };
    return CommentFooter;
}(React.Component));
export default withCommentContext(withVerification(withMobileContext(withTranslation()(CommentFooter))));
//# sourceMappingURL=CommentFooter.js.map